import { ReactElement } from 'react';
import { Field, useField } from 'formik';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/material';
import classNames from 'classnames';
import { visuallyHidden } from '@mui/utils';

type GridItemsAlignment = 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline';

// Types
interface IProps {
  checkboxAlignment?: GridItemsAlignment;
  callback?(): void;
  caption?: string;
  formikKey: string;
  name?: string;
  payloadValue?: boolean;
  shouldIgnoreCaptionStyling?: boolean;
}

export const FormikBooleanCheckboxField = (props: IProps): ReactElement => {
  const {
    callback,
    caption,
    checkboxAlignment = 'flex-start',
    formikKey,
    name,
    payloadValue,
    shouldIgnoreCaptionStyling = false,
  } = props;
  const [{ onChange, value }] = useField(formikKey);

  return (
    <Grid container wrap="nowrap">
      <Box component={Grid} sx={{ display: 'flex', alignItems: checkboxAlignment }}>
        <label className="form-input-checkbox">
          <Field
            onChange={callback || onChange}
            name={formikKey}
            type="checkbox"
            value={!!value}
            checked={payloadValue || !!value}
          />
          <span className="checkmark" />
          <span style={visuallyHidden}>{name}</span>
        </label>
      </Box>
      <Grid size={{ xs: 11 }}>
        <div className="label-text-container">
          <div className="label-text">{name}</div>
          <div
            className={classNames({ 'caption-text': !shouldIgnoreCaptionStyling })}
            dangerouslySetInnerHTML={{ __html: caption }}
          />
        </div>
      </Grid>
    </Grid>
  );
};
